import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { PublishedVersion, VersionChanges } from 'icreate/common/models/versions-history';
import { EnvironmentService } from './environment.service';
import { RuntimeEnvironments } from '../models/runtime-enviroment.enum';
import { VesselService } from './vessel.service';

@Injectable({
    providedIn: 'root',
})
export class VersionsHistoryService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService,
        private vesselService: VesselService
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getVersionsList(shipyardId: string, vesselId: string): Promise<PublishedVersion[]> {
        const currentEnv = this.environmentService.getEnvironment();
        if (currentEnv == RuntimeEnvironments.ELECTRON) {
            const activeVessel = this.vesselService.getActiveVessel();
            if (!activeVessel) return [];
            return [{ name: activeVessel.projectVersion, publishedDate: null }];
        }
        const params = {
            shipyardId,
            vesselId,
        };
        return await lastValueFrom(
            this.http.get<PublishedVersion[]>(`${this.domain}/api/versionsHistory/versionList`, {
                params,
            })
        );
    }

    async getVersionDifferences(
        iApiShipyardId: string,
        iAPIVesselId: string,
        version: string,
        previousVersion: string
    ): Promise<VersionChanges> {
        const currentEnv = this.environmentService.getEnvironment();
        if (currentEnv == RuntimeEnvironments.ELECTRON) return;
        const params = {
            iApiShipyardId,
            iAPIVesselId,
            version,
            previousVersion,
        };
        return await lastValueFrom(
            this.http.get<VersionChanges>(`${this.domain}/api/versionsHistory/compare`, {
                params,
            })
        );
    }

    async compareCurrent(iApiShipyardId: string, vesselId: string, iAPIVesselId: string): Promise<VersionChanges> {
        const currentEnv = this.environmentService.getEnvironment();
        if (currentEnv == RuntimeEnvironments.ELECTRON) return;
        const params = {
            iApiShipyardId,
            vesselId,
            iAPIVesselId,
        };
        return await lastValueFrom(
            this.http.get<VersionChanges>(`${this.domain}/api/versionsHistory/compare-current`, {
                params,
            })
        );
    }
}
